import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "navbar"
};
const _hoisted_2 = {
  class: "right-menu"
};
const _hoisted_3 = {
  class: "avatar-container"
};
const _hoisted_4 = {
  class: "avatar-wrapper"
};
const _hoisted_5 = ["src"];
import { ElMessageBox } from 'element-plus';
import { useStore } from 'vuex';
import { computed } from 'vue';
import Breadcrumb from '@/components/Breadcrumb';
import TopNav from '@/components/TopNav';
import Hamburger from '@/components/Hamburger';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
import HeaderSearch from '@/components/HeaderSearch';
export default {
  __name: 'index',
  emits: null,
  setup(__props, {
    emit: __emit
  }) {
    const store = useStore();
    const avatar = computed(() => store.getters['user/avatar']);
    const sidebar = computed(() => store.getters['app/sidebar']);
    const device = computed(() => store.getters['app/device']);
    function toggleSideBar() {
      store.dispatch('app/toggleSideBar');
    }
    function handleCommand(command) {
      switch (command) {
        case 'setLayout':
          setLayout();
          break;
        case 'logout':
          logout();
          break;
        default:
          break;
      }
    }
    function logout() {
      ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/logout').then(() => {
          location.href = '/login';
        });
      }).catch(() => {});
    }
    const emits = __emit;
    function setLayout() {
      emits('setLayout');
    }
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_caret_bottom = _resolveComponent("caret-bottom");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Hamburger), {
        id: "hamburger-container",
        "is-active": sidebar.value.opened,
        class: "hamburger-container",
        onToggleClick: toggleSideBar
      }, null, 8, ["is-active"]), !_ctx.$store.state.settings.topNav ? (_openBlock(), _createBlock(_unref(Breadcrumb), {
        key: 0,
        id: "breadcrumb-container",
        class: "breadcrumb-container"
      })) : _createCommentVNode("", true), _ctx.$store.state.settings.topNav ? (_openBlock(), _createBlock(_unref(TopNav), {
        key: 1,
        id: "topmenu-container",
        class: "topmenu-container"
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [device.value !== 'mobile' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_unref(HeaderSearch), {
        id: "header-search",
        class: "right-menu-item"
      }), _createVNode(_unref(Screenfull), {
        id: "screenfull",
        class: "right-menu-item hover-effect"
      }), _createVNode(_component_el_tooltip, {
        content: "布局大小",
        effect: "dark",
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_unref(SizeSelect), {
          id: "size-select",
          class: "right-menu-item hover-effect"
        })]),
        _: 1
      })], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_dropdown, {
        onCommand: handleCommand,
        class: "right-menu-item hover-effect",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: "/user/profile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("个人中心", -1)]))]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "setLayout"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("span", null, "布局设置", -1)]))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            divided: "",
            command: "logout"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("span", null, "退出登录", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          src: avatar.value,
          class: "user-avatar"
        }, null, 8, _hoisted_5), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_caret_bottom)]),
          _: 1
        })])]),
        _: 1
      })])])]);
    };
  }
};